import { VideoInputSvideoIcon } from './VideoInputSvideoIcon';

/**
 * author: Google
 * id EA3FB3E6-9696-4F01-AD34-5253E19EA34C
 * name video-input-svideo
 * version: 2.1.19
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/video-input-svideo.svg
 * tags
 * - Video / Movie 
 */
export const SettingsInputSvideoIcon = VideoInputSvideoIcon;
export default SettingsInputSvideoIcon